<template>
    <div class="d-flex">
        <h5 class="mb-0 mr-auto">
            {{ order.customer.full_name }}
            <i class="fa-solid fa-user fa-fw ml-2 mr-1"></i>{{ order.customer.id }}
            <a class="text-dark" :href="`/kit/view/${order.id}`"><i class="fa-solid fa-box fa-fw ml-2 mr-1"></i>{{ order.id }}</a>
        </h5>
        <FlagListHorizontal :flags="order.flags"></FlagListHorizontal>
    </div>
</template>

<script>
import FlagListHorizontal from '@/components/FlagListHorizontal';

export default {
    name: 'OrderCardHeader',
    components: {FlagListHorizontal,},
    props: ['order'],
    data() {
        return {
            };
    },
    methods: {
    },
    watch: {}
};
</script>

<style scoped>

</style>
